const MissionSection = () => {
  const churchImages = [
    "https://customer-assets.emergentagent.com/job_faith-media-hub/artifacts/aa2ip6g6_167393644_3805964839480669_2297204634654180317_n.jpg",
    "https://customer-assets.emergentagent.com/job_faith-media-hub/artifacts/v5taucde_168466908_3805965256147294_2721448358427313852_n.jpg",
  ];

  return (
    <section id="mission" className="section-spacing bg-white" data-testid="mission-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Hero Statement + Images */}
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <div>
            <p className="text-overline mb-6" data-testid="mission-overline">Mission Statement</p>
            <div className="accent-bar mb-8" />
            <h2 className="heading-massive text-4xl sm:text-5xl md:text-6xl text-black mb-8" data-testid="mission-heading">
              Light City<br />
              Church.
            </h2>
            <p className="font-['Satoshi'] text-lg text-zinc-600 leading-relaxed mb-6" data-testid="mission-description">
              Light City Church exists to raise a generation of Spirit-filled believers who know God intimately, walk in divine authority, and transform their world through the power of Jesus Christ.
            </p>
            <p className="font-['Satoshi'] font-semibold text-base text-black mb-3">We are committed to:</p>
            <ul className="font-['Satoshi'] text-lg text-zinc-600 leading-relaxed space-y-2 mb-6 list-none">
              <li className="flex items-start gap-2"><span className="text-[#FFB800] font-bold mt-1">-</span> Preaching the uncompromised Word of God</li>
              <li className="flex items-start gap-2"><span className="text-[#FFB800] font-bold mt-1">-</span> Demonstrating the power of the Holy Spirit</li>
              <li className="flex items-start gap-2"><span className="text-[#FFB800] font-bold mt-1">-</span> Building disciples, not just attendees</li>
              <li className="flex items-start gap-2"><span className="text-[#FFB800] font-bold mt-1">-</span> Advancing the Kingdom of God in our city and beyond</li>
            </ul>
            <p className="font-['Satoshi'] text-lg text-zinc-600 leading-relaxed" data-testid="mission-description-2">
              At our core, we exist to bring light into darkness, restore identity, and activate purpose in every believer.
            </p>
          </div>

          {/* Right: Sermon Spotlight Video */}
          <div className="relative">
            <div className="overflow-hidden">
              <p className="text-overline text-[#FFB800] mb-3">Sermon Spotlight</p>
              <video
                controls
                playsInline
                poster="https://customer-assets.emergentagent.com/job_faith-media-hub/artifacts/v4dhqwgy_IMG_1477.jpeg"
                className="w-full aspect-[9/16] md:aspect-[3/4] object-cover bg-black"
                data-testid="sermon-spotlight-video"
              >
                <source src="https://customer-assets.emergentagent.com/job_faith-media-hub/artifacts/c6wv4hre_Clip%201%20-%20Gospel%20for%20Your%20Family.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <p className="font-['Satoshi'] text-sm text-zinc-600 mt-3">
                Gospel for Your Family
              </p>
            </div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#FFB800] -z-10" />
          </div>
        </div>

        {/* Leadership of Chief Apostle */}
        <div className="mt-24 mb-24" data-testid="apostle-leadership">
          <p className="text-overline mb-4">The Leadership</p>
          <h3 className="font-['Clash_Display'] font-semibold text-3xl md:text-4xl text-black mb-10">
            Chief Apostle Leonard Lucas Jr.
          </h3>
          <p className="font-['Satoshi'] text-lg text-zinc-600 leading-relaxed mb-10 max-w-3xl">
            Chief Apostle Leonard Lucas Jr. is a visionary leader known for his father's heart and his prophetic precision. His ministry is characterized by:
          </p>
          <div className="grid md:grid-cols-3 gap-8" data-testid="leadership-traits">
            <div className="card-hard-shadow p-8 bg-white" data-testid="trait-card-0">
              <h4 className="font-['Clash_Display'] font-semibold text-xl mb-4">
                Apostolic Authority
              </h4>
              <p className="font-['Satoshi'] text-zinc-600 leading-relaxed">
                Establishing spiritual order and building a foundation where believers can grow into their own divine purpose.
              </p>
            </div>
            <div className="card-hard-shadow p-8 bg-white" data-testid="trait-card-1">
              <h4 className="font-['Clash_Display'] font-semibold text-xl mb-4">
                A Father to Generations
              </h4>
              <p className="font-['Satoshi'] text-zinc-600 leading-relaxed">
                He focuses on mentorship, raising up sons and daughters in the faith to carry the light into their respective spheres of influence.
              </p>
            </div>
            <div className="card-hard-shadow p-8 bg-white" data-testid="trait-card-2">
              <h4 className="font-['Clash_Display'] font-semibold text-xl mb-4">
                Uncompromising Truth
              </h4>
              <p className="font-['Satoshi'] text-zinc-600 leading-relaxed">
                Preaching a Word that challenges the status quo, heals the brokenhearted, and sets the captives free.
              </p>
            </div>
          </div>
        </div>

        {/* Our Vision */}
        <div className="mb-24" data-testid="crescent-city-mission">
          <p className="text-overline mb-4">Our Vision</p>
          <div className="accent-bar mb-8" />
          <p className="font-['Satoshi'] text-lg text-zinc-600 leading-relaxed mb-10 max-w-3xl">
            Our vision is to become a global apostolic movement that:
          </p>
          <div className="grid md:grid-cols-3 gap-8" data-testid="mission-pillars">
            <div className="card-hard-shadow p-8 bg-white" data-testid="pillar-card-0">
              <span className="font-['Clash_Display'] font-bold text-4xl text-[#FFB800]">01</span>
              <h4 className="font-['Clash_Display'] font-semibold text-xl mt-4 mb-4">
                Ignites Revival
              </h4>
              <p className="font-['Satoshi'] text-zinc-600 leading-relaxed">
                Ignites revival in cities and nations, sparking spiritual awakening wherever we go.
              </p>
            </div>
            <div className="card-hard-shadow p-8 bg-white" data-testid="pillar-card-1">
              <span className="font-['Clash_Display'] font-bold text-4xl text-[#FFB800]">02</span>
              <h4 className="font-['Clash_Display'] font-semibold text-xl mt-4 mb-4">
                Equips Believers
              </h4>
              <p className="font-['Satoshi'] text-zinc-600 leading-relaxed">
                Equips believers for spiritual dominion and influence in every area of life.
              </p>
            </div>
            <div className="card-hard-shadow p-8 bg-white" data-testid="pillar-card-2">
              <span className="font-['Clash_Display'] font-bold text-4xl text-[#FFB800]">03</span>
              <h4 className="font-['Clash_Display'] font-semibold text-xl mt-4 mb-4">
                Transforms Culture
              </h4>
              <p className="font-['Satoshi'] text-zinc-600 leading-relaxed">
                Transforms culture through the presence and power of God, building a thriving, Spirit-led community both in-person and online.
              </p>
            </div>
          </div>
        </div>

        {/* We See Light City As */}
        <div className="mb-24">
          <p className="text-overline mb-4">We See Light City Church As</p>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="card-hard-shadow p-8 bg-white">
              <h4 className="font-['Clash_Display'] font-semibold text-xl mb-4">
                A Hub of Revival
              </h4>
              <p className="font-['Satoshi'] text-zinc-600 leading-relaxed">
                Where lives are radically changed by the power of God.
              </p>
            </div>
            <div className="card-hard-shadow p-8 bg-white">
              <h4 className="font-['Clash_Display'] font-semibold text-xl mb-4">
                A Training Ground
              </h4>
              <p className="font-['Satoshi'] text-zinc-600 leading-relaxed">
                For leaders, prophets, and kingdom builders to be raised and equipped.
              </p>
            </div>
            <div className="card-hard-shadow p-8 bg-white">
              <h4 className="font-['Clash_Display'] font-semibold text-xl mb-4">
                A Beacon of Light
              </h4>
              <p className="font-['Satoshi'] text-zinc-600 leading-relaxed">
                In a dark world, fulfilling Matthew 5:14 — "You are the light of the world."
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="bg-black p-12 md:p-16 text-center" data-testid="mission-cta">
          <h3 className="font-['Clash_Display'] font-semibold text-3xl md:text-4xl text-white mb-6">
            Join the Movement
          </h3>
          <p className="font-['Satoshi'] text-lg text-white/80 leading-relaxed max-w-2xl mx-auto mb-8">
            When you connect with Light City Church, you aren't just joining a congregation; you are joining a movement.
          </p>
          <a href="#visit">
            <button
              className="btn-sharp bg-[#FFB800] text-black hover:bg-white px-10 py-4 font-['Clash_Display'] font-semibold text-sm uppercase tracking-widest transition-all duration-300"
              data-testid="mission-join-btn"
            >
              Plan Your Visit
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
